import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

/* Components */
import {Button} from '@stubhub/bamboo';
import {formatURLDomain} from '@stubhub/sh-url-utils';

import SVG from '../../../../components/icons/paperticket';
import NoTicketsAvailable from '../../../../components/react-no-tickets-available';

// CSS
import './index.scss';

const NoTicketsForEvent = ({eventId, webURI}, {globalRegistry}) => {
  const defaultLocale = globalRegistry?.getDefaultLocale();
  const currentLocale = globalRegistry?.getCurrentLocale();
  const sellUrl = formatURLDomain({href: `/sell/sellTicket?eventIds=${eventId}`, defaultLocale, currentLocale});
  const performerUrl =
    webURI &&
    formatURLDomain({
      href: `${!webURI.startsWith('/') ? '/' : ''}${webURI}`,
      defaultLocale,
      currentLocale,
    });

  /* @TODO place holder for svg image since it is not available */
  const svgImage = <SVG height="96px" width="93px" />;
  const headerText = <FormattedMessage id="NoTicketsForEvent.event.header" defaultMessage="No tickets... now what?" />;
  const buttonText = (
    <FormattedMessage id="NoTicketsForEvent.event.seeyourtickets" defaultMessage="Sell your tickets" />
  );

  return (
    <>
      {/* NoTicketsForEvent Top */}
      <NoTicketsAvailable
        className="NoTicketsForEvent__seeYourTicketsContainer"
        svgImage={svgImage}
        headerText={headerText}
        buttonText={buttonText}
        href={sellUrl}
      >
        <div className="NoTicketsForEvent__contents">
          <FormattedMessage
            id="NoTicketsForEvent.event.topcontent"
            defaultMessage="There are no tickets available for this event right now - check back soon!"
          />
          <div className="NoTicketsForEvent__separator" />
          <FormattedMessage
            id="NoTicketsForEvent.event.bottomcontent"
            defaultMessage="Or if for any reason you're not able to attend this event..."
          />
        </div>
      </NoTicketsAvailable>

      {webURI ? (
        // NoTicketsForEvent Bottom
        <div className="NoTicketsForEvent__upcomingEventsContainer">
          <Button className="NoTicketsForEvent__button" href={performerUrl} appearance="secondary">
            <FormattedMessage
              id="NoTicketsForEvent.event.upcomingeventsbutton"
              defaultMessage="See all upcoming events"
            />
          </Button>
          <span className="NoTicketsForEvent__upcomingEventText">
            <FormattedMessage
              id="NoTicketsForEvent.event.upcomingeventtext"
              defaultMessage="Interested in other options? Check out what we have available."
            />
          </span>
        </div>
      ) : null}
    </>
  );
};

NoTicketsForEvent.propTypes = {
  /** Redirect URI */
  webURI: PropTypes.string,

  /** Id of event */
  eventId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

NoTicketsForEvent.contextTypes = {
  globalRegistry: PropTypes.object,
};

export default NoTicketsForEvent;
